// knife preview
function KnifePreview() {
    var currentShapeState = React.useState(null);
    var currentShape = currentShapeState[0];
    var setCurrentShape = currentShapeState[1];
    
    var currentBladeState = React.useState(null);
    var currentBlade = currentBladeState[0];
    var setCurrentBlade = currentBladeState[1];
    
    var currentHandleState = React.useState(null);
    var currentHandle = currentHandleState[0];
    var setCurrentHandle = currentHandleState[1];
    
    var currentBladeDataState = React.useState(null);
    var currentBladeData = currentBladeDataState[0];
    var setCurrentBladeData = currentBladeDataState[1];
    
    var currentHandleDataState = React.useState(null);
    var currentHandleData = currentHandleDataState[0];
    var setCurrentHandleData = currentHandleDataState[1];
    
    var shapeLoadingState = React.useState(false);
    var shapeLoading = shapeLoadingState[0];
    var setShapeLoading = shapeLoadingState[1];
    
    var bladeLoadingState = React.useState(false);
    var bladeLoading = bladeLoadingState[0];
    var setBladeLoading = bladeLoadingState[1];
    
    var handleLoadingState = React.useState(false);
    var handleLoading = handleLoadingState[0];
    var setHandleLoading = handleLoadingState[1];
    
    var shapeTimeoutRef = React.useRef(null);
    var bladeTimeoutRef = React.useRef(null);
    var handleTimeoutRef = React.useRef(null);
    
    var DEFAULT_HANDLE_PREVIEW_SHAPE = 'santoku';
    
    var shapeImages = {
        santoku: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-santoku.png?v=1769401464',
        nakiri: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-nakiri.png?v=1769401464',
        gyuto: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-gyuto.png?v=1769401464',
        bunka: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-bunka.png?v=1769401464',
        kobunka: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-kobunka.png?v=1769401464',
        petty: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-petty.png?v=1769401464',
        'kiritsuke-petty': 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-kiritsuke-petty.png?v=1769401464',
        kiritsuke: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-kiritsuke.png?v=1769401464'
    };
    
    var SHAPE_TO_HANDLE_PREVIEW_KEY = {
        'santoku': 'custom.handle_santoku_preview',
        'nakiri': 'custom.handle_nakiri_preview',
        'gyuto': 'custom.handle_gyuto_preview',
        'bunka': 'custom.handle_bunka_preview',
        'kobunka': 'custom.handle_kobunka_preview',
        'petty': 'custom.handle_petty_preview',
        'kiritsuke-petty': 'custom.handle_kiritsuke_petty_preview',
        'kiritsuke': 'custom.handle_kiritsuke_preview'
    };
    
    var TAG_TO_SHAPE = {
        'Santoku': 'santoku',
        'Nakiri': 'nakiri',
        'Gyuto': 'gyuto',
        'Bunka': 'bunka',
        'Kobunka': 'kobunka',
        'Petty': 'petty',
        'Kiritsuke Petty': 'kiritsuke-petty',
        'Kiritsuke': 'kiritsuke'
    };
    
    var isLoading = shapeLoading || bladeLoading || handleLoading;
    
    var preloadImage = function(src, type) {
        return new Promise(function(resolve, reject) {
            if (!src) {
                resolve();
                return;
            }
            
            if (type === 'shape' && shapeTimeoutRef.current) {
                clearTimeout(shapeTimeoutRef.current);
                shapeTimeoutRef.current = null;
            } else if (type === 'blade' && bladeTimeoutRef.current) {
                clearTimeout(bladeTimeoutRef.current);
                bladeTimeoutRef.current = null;
            } else if (type === 'handle' && handleTimeoutRef.current) {
                clearTimeout(handleTimeoutRef.current);
                handleTimeoutRef.current = null;
            }
            
            if (type === 'shape') setShapeLoading(true);
            else if (type === 'blade') setBladeLoading(true);
            else if (type === 'handle') setHandleLoading(true);
            
            var img = new Image();
            img.onload = function() {
                if (type === 'shape') setShapeLoading(false);
                else if (type === 'blade') setBladeLoading(false);
                else if (type === 'handle') setHandleLoading(false);
                resolve();
            };
            img.onerror = function() {
                if (type === 'shape') setShapeLoading(false);
                else if (type === 'blade') setBladeLoading(false);
                else if (type === 'handle') setHandleLoading(false);
                reject();
            };
            img.src = src;
        });
    };
    
    var getShapeFromBladeTags = function(tags) {
        if (!tags || !Array.isArray(tags)) return null;
        for (var i = 0; i < tags.length; i++) {
            var tag = tags[i];
            if (TAG_TO_SHAPE[tag]) {
                return TAG_TO_SHAPE[tag];
            }
        }
        return null;
    };
    
    var getBladePreviewImage = function(bladeData) {
        if (!bladeData || !bladeData.metafields) return null;
        return bladeData.metafields['custom.blade_customization_preview'] || null;
    };
    
    var getHandlePreviewImage = function(handleData, shapeId, bladeData) {
        if (!handleData || !handleData.metafields) return null;
        
        var effectiveShape = shapeId;
        
        if (!effectiveShape && bladeData) {
            effectiveShape = getShapeFromBladeTags(bladeData.tags);
        }
        
        if (!effectiveShape) {
            effectiveShape = DEFAULT_HANDLE_PREVIEW_SHAPE;
        }
        
        var previewKey = SHAPE_TO_HANDLE_PREVIEW_KEY[effectiveShape];
        if (!previewKey) return null;
        
        return handleData.metafields[previewKey] || 
               handleData.metafields[SHAPE_TO_HANDLE_PREVIEW_KEY[DEFAULT_HANDLE_PREVIEW_SHAPE]] || 
               null;
    };
    
    var getEffectiveShapeForHandle = function(shapeId, bladeData) {
        if (shapeId) return shapeId;
        if (bladeData) {
            var bladeShape = getShapeFromBladeTags(bladeData.tags);
            if (bladeShape) return bladeShape;
        }
        return DEFAULT_HANDLE_PREVIEW_SHAPE;
    };
    
    React.useEffect(function() {
        var checkState = setInterval(function() {
            if (typeof window.KnifeCustomizationState === 'undefined') return;
            
            var newShape = window.KnifeCustomizationState.selectedShape;
            var newBlade = window.KnifeCustomizationState.selectedBlade;
            var newHandle = window.KnifeCustomizationState.selectedHandle;
            var newBladeData = window.KnifeCustomizationState.selectedBladeData;
            var newHandleData = window.KnifeCustomizationState.selectedHandleData;
            
            if (newShape !== currentShape) {
                setCurrentShape(newShape);
                if (newShape && shapeImages[newShape]) {
                    preloadImage(shapeImages[newShape], 'shape');
                } else {
                    setShapeLoading(false);
                }
            }
            
            if (newBlade !== currentBlade || newBladeData !== currentBladeData) {
                setCurrentBlade(newBlade);
                setCurrentBladeData(newBladeData);
                var bladePreviewImg = getBladePreviewImage(newBladeData);
                if (bladePreviewImg) {
                    preloadImage(bladePreviewImg, 'blade');
                } else {
                    setBladeLoading(false);
                }
            }
            
            var currentEffectiveShape = getEffectiveShapeForHandle(currentShape, currentBladeData);
            var newEffectiveShape = getEffectiveShapeForHandle(newShape, newBladeData);
            
            if (newHandle !== currentHandle || 
                newHandleData !== currentHandleData || 
                newEffectiveShape !== currentEffectiveShape) {
                setCurrentHandle(newHandle);
                setCurrentHandleData(newHandleData);
                var handlePreviewImg = getHandlePreviewImage(newHandleData, newShape, newBladeData);
                if (handlePreviewImg) {
                    preloadImage(handlePreviewImg, 'handle');
                } else {
                    setHandleLoading(false);
                }
            }
        }, 100);
        
        return function() { clearInterval(checkState); };
    }, [currentShape, currentBlade, currentHandle, currentBladeData, currentHandleData]);
    
    React.useEffect(function() {
        return function() {
            if (shapeTimeoutRef.current) clearTimeout(shapeTimeoutRef.current);
            if (bladeTimeoutRef.current) clearTimeout(bladeTimeoutRef.current);
            if (handleTimeoutRef.current) clearTimeout(handleTimeoutRef.current);
        };
    }, []);
    
    var bladePreviewImage = getBladePreviewImage(currentBladeData);
    var handlePreviewImage = getHandlePreviewImage(currentHandleData, currentShape, currentBladeData);
    
    var dropShadowStyle = 'drop-shadow(0 12px 32px rgba(0, 0, 0, 0.1))';
    
    return React.createElement('div', {
        style: { 
            position: 'relative', 
            width: '100%', 
            height: '100%',
            minHeight: '400px',
            display: 'block'
        }
    },
        isLoading && React.createElement('div', { className: 'progress-root' },
            React.createElement('div', { className: 'progress-track' },
                React.createElement('div', { className: 'progress-range' }, '\u00A0')
            )
        ),
        
        React.createElement('div', {
            style: {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                opacity: isLoading ? 0.3 : 1,
                transition: 'opacity 0.3s ease'
            }
        },
            currentShape && shapeImages[currentShape] && !currentBlade && !currentHandle && !shapeLoading && React.createElement('img', {
                src: shapeImages[currentShape],
                alt: currentShape + ' knife shape',
                style: {
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    filter: dropShadowStyle
                }
            }),
            
            currentBlade && bladePreviewImage && !bladeLoading && React.createElement('img', {
                src: bladePreviewImage,
                alt: currentBlade + ' blade',
                style: {
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    zIndex: 1,
                    objectFit: 'contain',
                    filter: dropShadowStyle
                }
            }),
            
            currentHandle && handlePreviewImage && !handleLoading && React.createElement('img', {
                src: handlePreviewImage,
                alt: currentHandle + ' handle',
                style: {
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 2,
                    objectFit: 'contain',
                    filter: dropShadowStyle
                }
            }),
            
            !currentShape && !currentBlade && !currentHandle && !isLoading && React.createElement('div', {
                style: {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    color: 'rgba(255, 255, 255, 0.2)',
                    fontSize: '14px',
                    textAlign: 'center',
                    whiteSpace: 'nowrap'
                }
            }, 'Select options to preview your knife')
        )
    );
}

window.KnifePreview = KnifePreview;